import React from "react";

// Helper function to calculate remaining days with proper time consideration
const getRemaindays = (last_date) => {
  if (!last_date) return null;

  const now = new Date();
  const targetDate = new Date(last_date);

  // Set both dates to midnight for accurate day difference calculation
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const target = new Date(targetDate.getFullYear(), targetDate.getMonth(), targetDate.getDate());

  // Calculate difference in days
  const diffTime = target - today;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return diffDays;
};

export default function LabelgetRemaindays({ last_date }) {
  const day = getRemaindays(last_date);

  if (day == null || day == undefined) {
    return (
      <div className="post-img">
        <p style={{ color: "orange" }} className="progress-p">
          <i className="fa-regular fa-clock" aria-hidden="true"></i> Invalid Date
        </p>
      </div>
    );
  }

  const absoluteDays = Math.abs(day);
  let message;
  let color = "orange"; // default color

  // For days > 365 (more than a year)
  if (absoluteDays > 365) {
    const years = Math.floor(absoluteDays / 365);
    const months = Math.floor((absoluteDays % 365) / 30);
    const days = absoluteDays % 30;

    message = `${years} year${years > 1 ? "s" : ""}`;
    if (months > 0) message += ` ${months} month${months > 1 ? "s" : ""}`;
    if (days > 0) message += ` ${days} day${days > 1 ? "s" : ""} left`;
    color = "green";
  }
  // For days > 30 (more than a month but less than a year)
  else if (absoluteDays > 30) {
    const months = Math.floor(absoluteDays / 30);
    const days = absoluteDays % 30;

    message = `${months} month${months > 1 ? "s" : ""}`;
    if (days > 0) message += ` ${days} day${days > 1 ? "s" : ""} left`;
    color = "green";
  }
  // For 30 days or less
  else {
    if (day == 1) {
      message = `Due Tomorrow`;
      color = "orange";
    } else if (day > 1) {
      message = `${absoluteDays} day${absoluteDays > 1 ? "s" : ""} left`;
      color = "green";
    } else if (day == 0) {
      message = `Due Today`;
      color = "red";
    } else if (day == -1) {
      message = `1 day delay`;
      color = "red";
    } else if (day < -1) {
      message = `${absoluteDays} day${absoluteDays > 1 ? "s" : ""} delay`;
      color = "red";
    } else {
      message = `${absoluteDays} day left`;
      color = "orange";
    }
  }

  return (
    <div className="post-img">
      <p style={{ color: color }}>
        <i className="fa-regular fa-clock" aria-hidden="true"></i> {message}
      </p>
    </div>
  );
}